<template>
  <hr/>
  <div class="row">
    <div style = "text-align:center;margin-top:2px;">
      <div style="font-size:.9rem;">
        <span><a href="/release-note">릴리즈 노트</a></span> |
        <span><a href="https://krksap.tistory.com">oceanfog1@gmail.com</a></span> |
        <span><a href="https://krksap.tistory.com">Blog</a></span>
      </div>
      <div style="margin-top:1rem;">
        <h6>By Kyeongrok Kim</h6>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "BibleFinderFooter"
}
</script>

<style scoped>

</style>
